import React from 'react'
import Panel from '../Panel'
import style from './style.module.less'
import { Flex } from 'hljd'
import { Button } from 'hljd'
import { dGet } from '@core/utils'
import {
  TASK_STATUS_MAPPING,
  TASK_STATUS_TODO,
  TASK_STATUS_DONE,
  TASK_STATUS_EXPIRED
} from '@components/JiaMeng/NewCustomer/constant'
import cls from 'classnames'
import LabelText from '../LabelText'

const TaskCard = ({ store, operator, item }) => {
  const { created_at, title } = item
  const {
    remark,
    customer_name,
    status,
    finished_remark,
    finished_at,
    expired_at
  } = dGet(item, 'task_card', {})

  const isTodo = status == TASK_STATUS_TODO
  const isDone = status == TASK_STATUS_DONE
  const isExpired = status == TASK_STATUS_EXPIRED

  return (
    <Panel
      title={
        <Flex vc>
          <Flex vc className={style.title}>
            <img
              src="//qnm.hunliji.com/o_1d8n5956poq6gmhlrn1nric5j9.png"
              style={{ width: 24, height: 24, marginRight: 8 }}
            />
            <span>{title}</span>
          </Flex>

          <div
            className={cls(style.status, {
              [style.statusDone]: isDone,
              [style.statusTodo]: isTodo,
              [style.statusExpired]: isExpired
            })}
          >
            {TASK_STATUS_MAPPING[String(status)]}
          </div>
        </Flex>
      }
      item={item}
      extra={isDone ? finished_at : isExpired ? expired_at : null}
    >
      <LabelText label="任务时间" block>
        {dGet(item, 'task_card.task.remind_time')}
      </LabelText>
      <LabelText label="内容" block>
        {remark}
      </LabelText>

      {status == TASK_STATUS_TODO && (
        <Button
          type="primary"
          onClick={() => {
            store.getCurrentTask(dGet(item, 'task_card.task_id'))
            store.setStoreData([
              { type: 'confirmTaskModalVisible', value: true }
            ])
          }}
          style={{ marginBottom: 20 }}
        >
          确认完成
        </Button>
      )}

      {status == TASK_STATUS_DONE && (
        <LabelText label="完成备注" block>
          {finished_remark}
        </LabelText>
      )}

      <div>
        <LabelText label="操作人" style={{ marginRight: 30 }}>
          {operator}
        </LabelText>
        <LabelText label="创建时间" style={{ marginRight: 30 }}>
          {created_at}
        </LabelText>
        <LabelText label="相关客户">{customer_name}</LabelText>
      </div>
    </Panel>
  )
}

export default TaskCard
